export default "__VITE_ASSET__DflixZ1S__"